/* LUMINIX — zachowania motywu. Bez bibliotek: koszyk, wybór zestawu, galeria, menu, zakładki. */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Menu na telefonie */
  var toggle = $('[data-nav-toggle]');
  var nav = $('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Zakładki na stronie głównej */
  $$('[data-tabs]').forEach(function (box) {
    $$('[data-tab]', box).forEach(function (btn) {
      btn.addEventListener('click', function () {
        $$('[data-tab]', box).forEach(function (b) { b.classList.remove('is-on'); b.setAttribute('aria-selected', 'false'); });
        btn.classList.add('is-on'); btn.setAttribute('aria-selected', 'true');
        $$('[data-panel]', box).forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== btn.getAttribute('data-tab'); });
      });
    });
  });

  /* Galeria: miniatury przewijają do slajdu, przewijanie palcem podświetla miniaturę */
  var gal = $('[data-gallery]');
  if (gal) {
    var thumbs = $$('[data-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = +t.getAttribute('data-thumb') - 1;
        gal.scrollTo({ left: gal.clientWidth * i, behavior: 'smooth' });
      });
    });
    var tick;
    gal.addEventListener('scroll', function () {
      clearTimeout(tick);
      tick = setTimeout(function () {
        var i = Math.round(gal.scrollLeft / gal.clientWidth);
        thumbs.forEach(function (t, n) { t.classList.toggle('is-on', n === i); });
      }, 60);
    });
  }

  /* Wybór zestawu: cena i przekreślona kwota idą z atrybutów wyrenderowanych przez Shopify */
  var form = $('#ProductForm');
  if (form) {
    var price = $('[data-price]');
    var compare = $('[data-compare]');
    var stickyPrice = $('[data-sticky-price]');
    $$('input[name="id"][type="radio"]', form).forEach(function (input) {
      input.addEventListener('change', function () {
        $$('.tier', form).forEach(function (l) { l.classList.toggle('is-on', l.contains(input)); });
        if (price) price.textContent = input.getAttribute('data-price');
        if (stickyPrice) stickyPrice.textContent = input.getAttribute('data-price');
        var old = input.getAttribute('data-old');
        if (compare) { compare.textContent = old; compare.hidden = !old; }
        var url = new URL(location.href);
        url.searchParams.set('variant', input.value);
        history.replaceState({}, '', url);
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btns = $$('[name="add"]');
      btns.forEach(function (b) { b.disabled = true; });
      var err = $('[data-form-error]');
      if (err) err.hidden = true;
      var data = new FormData(form);
      data.append('sections', 'cart-drawer');
      data.append('sections_url', location.pathname);
      fetch(window.LMX.routes.cartAdd + '.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || window.LMX.strings.error);
          renderCart(res.body.sections && res.body.sections['cart-drawer']);
          openCart();
        })
        .catch(function (ex) { if (err) { err.textContent = ex.message; err.hidden = false; } })
        .finally(function () { btns.forEach(function (b) { b.disabled = false; }); });
    });

    /* Przyklejony przycisk na telefonie — gdy główny zniknie z ekranu */
    var atc = $('[data-atc]');
    var sticky = $('[data-sticky-atc]');
    if (atc && sticky && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(function (entries) {
        var past = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-shown', past && window.innerWidth < 990);
      }).observe(atc);
    }
  }

  /* Data dostawy: dziś + 2 dni robocze, w języku strony */
  var when = $('[data-delivery-date]');
  if (when) {
    var d = new Date(); var added = 0;
    while (added < 2) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) added++; }
    try { when.textContent = d.toLocaleDateString(document.documentElement.lang || 'pl', { weekday: 'long', day: 'numeric', month: 'long' }); } catch (e) { when.textContent = d.toDateString(); }
  }

  /* Śledzenie przesyłki → 17TRACK */
  var track = $('[data-track-form]');
  if (track) {
    track.addEventListener('submit', function (e) {
      e.preventDefault();
      var no = (track.elements.nums.value || '').replace(/\s+/g, '');
      if (!no) return;
      window.open('https://t.17track.net/' + (window.LMX.locale || 'en').slice(0, 2) + '#nums=' + encodeURIComponent(no), '_blank', 'noopener');
    });
  }

  /* Koszyk z boku */
  var drawer = $('[data-cart-drawer]');
  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }
  function renderCart(html) {
    if (!html || !drawer) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = $('[data-cart-drawer]', tmp);
    if (!fresh) return;
    var wasOpen = drawer.classList.contains('is-open');
    drawer.innerHTML = fresh.innerHTML;
    if (wasOpen) drawer.classList.add('is-open');
    var body = $('[data-cart-body]', drawer);
    var count = body ? +body.getAttribute('data-count') : 0;
    $$('[data-cart-count]').forEach(function (c) { c.textContent = count; c.hidden = count === 0; });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : e.target.parentElement;
    if (t.closest('[data-cart-open]')) { e.preventDefault(); openCart(); return; }
    if (t.closest('[data-cart-close]')) { closeCart(); return; }
    var q = t.closest('[data-qty]');
    if (q && drawer && drawer.contains(q)) {
      fetch(window.LMX.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: q.getAttribute('data-key'), quantity: +q.getAttribute('data-qty'), sections: 'cart-drawer', sections_url: location.pathname })
      }).then(function (r) { return r.json(); }).then(function (j) { renderCart(j.sections && j.sections['cart-drawer']); });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
})();
